export const RESET_STATE = 'RESET_STATE';